/* eslint-disable max-len */
import Link from 'next/link';
import React from 'react';
import { useTheme } from 'styled-components';
import Button from '../buttons/Button';
import PageWrapper from '../layout/PageWrapper';
import PPMLogoMedium from '../logos/propertypal-mortgages/PPMLogo.style';
import MortgageBenefits from '../mortgages/mortgage-benefits/MortgageBenefits';
import {
  MortgageJumboTronContainer,
  MortgageJumboTronFooter,
  MortgageJumboTronInner,
} from './MortgageIntroJumobTron.style';

interface Props {
  isMortgageLanding?: boolean;
}

const MortgageIntroJumboTron: React.FC<Props> = (props) => {
  const { isMortgageLanding } = props;
  const theme = useTheme();

  return (
    <PageWrapper noMaxWidth>
      <MortgageJumboTronContainer>
        <MortgageJumboTronInner isMortgageLanding={isMortgageLanding}>
          <PPMLogoMedium />

          <h1>Can I get a mortgage?</h1>

          <h2>
            Find out if you&apos;re eligible for a mortgage <b>AND</b> how much you can borrow.
          </h2>

          <Link href="/mortgages/pre-approval/1">
            <Button color={theme.background} fontColor={theme.textDark}>
              Find out now
            </Button>
          </Link>
        </MortgageJumboTronInner>

        <MortgageJumboTronFooter>
          <MortgageBenefits border={0.1} padding="0px 10px" maxWidth={1500} breakPoint="1265px" />
        </MortgageJumboTronFooter>
      </MortgageJumboTronContainer>
    </PageWrapper>
  );
};

export default MortgageIntroJumboTron;
